// extracted by mini-css-extract-plugin
export default {"search":"SearchInput-module__search--QKypA","input":"SearchInput-module__input--DXD9z"};